/**
 *
 * TableAvatarSkeleton
 *
 */

import React, { memo } from 'react';

import Skeleton from '..';

function TableAvatarSkeleton(props) {
  return <Skeleton variant="circular" width={24} height={24} {...props} />;
}

export default memo(TableAvatarSkeleton);
